<div class="checkin-issue-modal">
    <div class="modal-header-custom">
        <h4 class="modal-title">Report Check-in Issue</h4>
        <button type="button" class="close-btn" (click)="onClose()">
            <i class="material-icons">close</i>
        </button>
    </div>
    <div class="modal-body-custom">
        <p class="description-text">
            Please describe the issue you faced during check-in. Our support team will reach out to the hotel immediately.
        </p>
        <textarea
            class="issue-textarea"
            [(ngModel)]="issueDescription"
            placeholder="Describe your check-in issue here..."
            rows="5"
            maxlength="1024"
        ></textarea>
        <button 
            class="submit-btn" 
            (click)="onSubmit()"
            [disabled]="isSubmitting"
        >
            <span *ngIf="!isSubmitting">SUBMIT ISSUE REPORT</span>
            <span *ngIf="isSubmitting">SUBMITTING...</span>
        </button>
        <p class="footer-text">You will hear back from us soon.</p>
    </div>
</div>
